import { createFileRoute } from "@tanstack/react-router";
import BcbsSaintPage from "@/pages/learn/BcbsSaintPage";
export const Route = createFileRoute(
  "/insurance/blue-cross-blue-shield-saint-tms",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "BCBS SAINT® TMS Coverage | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Blue Cross Blue Shield coverage for SAINT® TMS varies by plan and state. We verify your benefits for free at Neuro Wellness in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "BCBS SAINT® TMS Coverage | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Blue Cross Blue Shield coverage for SAINT® TMS varies by plan and state. We verify your benefits for free at Neuro Wellness in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/insurance/blue-cross-blue-shield-saint-tms",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/insurance/blue-cross-blue-shield-saint-tms",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <BcbsSaintPage />;
}
